import { gql } from '@apollo/client';

export type SET_METABASE_DASHBOARD_ASSIGNED_USERSInputType = {
  metabaseId: number;
  metabaseName: string;
  users: {
    userId: string;
    startDate?: string | null;
    endDate?: string | null;
  }[];
};

export const SET_METABASE_DASHBOARD_ASSIGNED_USERS = gql`
  mutation SetMetabaseDashboardAssignedUsers($input: SetMetabaseDashboardAssignedUsersInput!) {
    data: setMetabaseDashboardAssignedUsers(input: $input) {
      id
      metabaseId
      metabaseName
      startDate
      endDate
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
